import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectCurrentChapterAdmin } from '../app/features/chapterAdminSlice';
import { useGetMonitorChapterShareMutation } from '../app/services/chapterServices';
import { toast } from 'react-toastify';
import Spinner from "./spinner/spinner"


function ChapterShare() {
    const chapterData = useSelector(selectCurrentChapterAdmin)
    const [chaptermonitor, { isLoading }] = useGetMonitorChapterShareMutation()
    const [shareData, setShareData] = useState([]);
    // const dispatch = useDispatch();
    const { handleSubmit, register, formState: { errors } } = useForm({
        mode: 'onChange', defaultValues: {
            chapterId: chapterData?._id,
            fromYear: new Date().getFullYear(),
            fromMonth: 1,
            toYear: '',
            toMonth: 12
        },
    });

    const getData = (formData) => {
        const updatedData = { ...formData, toYear: formData?.fromYear }
        chaptermonitor(updatedData).then((res) => {
            if (res?.data?.data) {
                const updated = res?.data?.data?.financialReport.map(report => ({
                    month: report.month,
                    year: report.fromYear,
                    credit: report?.credit,
                    debit: report?.debit,
                    balance: report?.balance,
                    entriesBalance: report?.entriesBalance,
                    paymentEntries: report?.paymentEntries || []
                }))
                setShareData(updated)
                toast.success(res?.data?.message)
            }
            else {
                setShareData([])
                toast.error(res?.data?.err?.message)
            }
        })
    }
    return (
        <>
            <div className="pt-5 d-print-none">
                <div className="chapter-heading ">
                    <h2 className="text-center title-font text-light py-3 mt-1">15 % Share from Membership Fees</h2>
                </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
                <div className='text-end mb-3 d-print-none'>
                    <Button onClick={() => window.history.back()} variant="contained" className='menus-color'
                    >Back</Button>
                </div>
                <Box component={'form'} onSubmit={handleSubmit(getData)}>
                    <Grid container className='d-flex align-items-start justify-content-center'>
                        <Grid item xs={12} md={6} lg={4}>
                            <span>
                                Name of the ELTAI Chapter: <span className='text-secondary-new fw-bold fs-5'>{chapterData?.title}</span>
                            </span>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4} className='d-flex gap-3'>
                            <TextField fullWidth  {...register('fromYear', {
                                required: 'Please enter a year',
                                max: {
                                    value: new Date().getFullYear().toString(),
                                    message: 'Please enter a present or past year'
                                },
                                min: {
                                    value: 2025,
                                    message: 'Minimum year is 2025'
                                },
                                pattern: {
                                    value: /^\d{4}$/,
                                    message: "Year must be 4 digits",
                                }
                            })}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        paddingInline: '7px !important', // Adjust label padding
                                        paddingBlock: '8px !important', // Adjust label padding
                                    },
                                }}
                                error={!!errors?.fromYear}
                                helperText={errors?.fromYear?.message}
                                label={<Typography className='text-dark'> Year <span className='text-danger'>*</span> </Typography>} />
                            <div className="text-center w-50">
                                <Button type='submit' disabled={isLoading} variant="contained" className="rounded-0 d-print-none" color="secondary">Get Data</Button>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
                {isLoading ? <Spinner></Spinner> : shareData.length > 0 ? <TableContainer component={Paper} className='mt-3 shadow-none'>
                    <Table>
                        <TableHead sx={{ bgcolor: 'secondary.main' }}>
                            <TableRow>
                                <TableCell className="border text-white">Month & Year</TableCell>
                                <TableCell className="border text-white">Description</TableCell>
                                <TableCell className="border text-white">Credit</TableCell>
                                <TableCell className="border text-white">Debit</TableCell>
                                <TableCell className="border text-white">Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {shareData?.map((data, index) => (
                                <><TableRow key={index}>
                                    <TableCell className="border" rowSpan={data?.paymentEntries.length + 1}>{data.month} {data.year}</TableCell>
                                    <TableCell className="border">-----</TableCell>
                                    <TableCell className="border">{data.credit || "-----"}</TableCell>
                                    <TableCell className="border">{data.debit || "-----"}</TableCell>
                                    <TableCell className="border">{data.entriesBalance || "-----"}</TableCell>
                                </TableRow>
                                    {data?.paymentEntries.length > 0 && data?.paymentEntries.map((pay, payIndex) => (
                                        <TableRow key={payIndex}>
                                            <TableCell className="border">{pay?.description}</TableCell>
                                            {pay?.payType.toString() === '0' ? <>
                                                <TableCell className="border">{pay.amount}</TableCell>
                                                <TableCell>-----</TableCell>
                                            </>
                                                : <>
                                                    <TableCell>-----</TableCell>
                                                    <TableCell className="border">{pay.amount}</TableCell>
                                                </>}
                                            <TableCell className="border">{pay.balance}</TableCell>
                                        </TableRow>
                                    ))}
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                    :
                    <p className='text-center mt-5'>Enter a year and click get data.</p>}
            </div>

        </>
    )
}

export default ChapterShare